function groupDecimal(value: string): string {
  const [integerPart, decimalPart = ''] = value.split('.');
  const grouped = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const trimmedDecimal = decimalPart.replace(/0+$/, '');
  return `${grouped}${trimmedDecimal ? `.${trimmedDecimal}` : ''}`;
}

export function formatYuan(value: string | null | undefined): string {
  if (!value) {
    return '-';
  }

  return `${groupDecimal(value)} 元`;
}

export function formatWanYuan(value: string | null | undefined): string {
  if (!value) {
    return '-';
  }
  return `${groupDecimal(value)} 万元`;
}
